import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableLiteToV3FtuPreCompletion = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableLiteToV3FtuPreCompletion);
};
